document.addEventListener("DOMContentLoaded", () => {
    const carousels = document.querySelectorAll(".depoimentos-carousel-wrapper");

    carousels.forEach((carousel) => {
        const track = carousel.querySelector(".depoimentos-carousel-track");
        const slides = carousel.querySelectorAll(".depoimento-slide");
        const dotsContainer = carousel.querySelector(".depoimentos-carousel-dots");

        if (!slides.length) return;

        let currentIndex = 0;
        let autoplayTimer = null;
        const AUTOPLAY_DELAY = 5000; // 5 segundos

        // Controle de swipe/drag
        let startX = 0;
        let currentX = 0;
        let isDragging = false;
        let startTranslate = 0;
        let hasMoved = false;

        const getVisibleSlides = () => {
            if (window.innerWidth <= 600) return 1;
            if (window.innerWidth <= 992) return 2;
            return 3;
        };

        const getMaxIndex = () => Math.max(0, slides.length - getVisibleSlides());

        const getSlideStep = () => {
            const style = window.getComputedStyle(track);
            const gap = parseFloat(style.columnGap || style.gap) || 30;
            return slides[0].getBoundingClientRect().width + gap;
        };

        const renderDots = () => {
            dotsContainer.innerHTML = "";
            const totalDots = getMaxIndex() + 1;

            if (totalDots <= 1) return;

            for (let i = 0; i < totalDots; i++) {
                const dot = document.createElement("div");
                dot.classList.add("dot");
                if (i === currentIndex) dot.classList.add("active");
                dot.addEventListener("click", () => {
                    goToSlide(i);
                    restartAutoplay();
                });
                dotsContainer.appendChild(dot);
            }
        };

        const goToSlide = (index) => {
            currentIndex = Math.min(Math.max(0, index), getMaxIndex());
            const offset = currentIndex * getSlideStep();

            track.style.transition = "transform 0.4s ease-in-out";
            track.style.transform = `translateX(-${offset}px)`;

            const dots = dotsContainer.querySelectorAll(".dot");
            dots.forEach((dot, idx) => {
                dot.classList.toggle("active", idx === currentIndex);
            });
        };

        const nextSlide = () => {
            const maxIndex = getMaxIndex();
            if (currentIndex >= maxIndex) {
                goToSlide(0);
            } else {
                goToSlide(currentIndex + 1);
            }
        };

        const prevSlide = () => {
            if (currentIndex <= 0) {
                goToSlide(getMaxIndex());
            } else {
                goToSlide(currentIndex - 1);
            }
        };

        // Autoplay
        const startAutoplay = () => {
            stopAutoplay();
            if (getMaxIndex() <= 0) return;
            autoplayTimer = setInterval(nextSlide, AUTOPLAY_DELAY);
        };

        const stopAutoplay = () => {
            if (autoplayTimer) {
                clearInterval(autoplayTimer);
                autoplayTimer = null;
            }
        };

        const restartAutoplay = () => {
            stopAutoplay();
            startAutoplay();
        };

        // Pausa ao passar o mouse (desktop)
        carousel.addEventListener("mouseenter", stopAutoplay);
        carousel.addEventListener("mouseleave", startAutoplay);

        // ----- Swipe / Drag -----
        const getX = (e) => {
            if (e.touches && e.touches.length) return e.touches[0].clientX;
            return e.clientX;
        };

        const onDragStart = (e) => {
            isDragging = true;
            hasMoved = false;
            startX = getX(e);
            currentX = startX;
            startTranslate = -currentIndex * getSlideStep();
            track.style.transition = "none";
            stopAutoplay();
        };

        const onDragMove = (e) => {
            if (!isDragging) return;
            currentX = getX(e);
            const diff = currentX - startX;

            if (Math.abs(diff) > 5) {
                hasMoved = true;
                // Evita scroll vertical indesejado durante swipe horizontal em touch
                if (e.cancelable && e.type === "touchmove") {
                    e.preventDefault();
                }
            }

            track.style.transform = `translateX(${startTranslate + diff}px)`;
        };

        const onDragEnd = () => {
            if (!isDragging) return;
            isDragging = false;

            const diff = currentX - startX;
            const threshold = getSlideStep() * 0.2; // 20% do slide

            if (diff < -threshold) {
                nextSlide();
            } else if (diff > threshold) {
                prevSlide();
            } else {
                goToSlide(currentIndex);
            }

            restartAutoplay();
        };

        // Touch events
        track.addEventListener("touchstart", onDragStart, { passive: true });
        track.addEventListener("touchmove", onDragMove, { passive: false });
        track.addEventListener("touchend", onDragEnd);
        track.addEventListener("touchcancel", onDragEnd);

        // Mouse events (drag no desktop)
        track.addEventListener("mousedown", (e) => {
            e.preventDefault();
            onDragStart(e);
        });
        window.addEventListener("mousemove", onDragMove);
        window.addEventListener("mouseup", onDragEnd);

        // Previne clique acidental após arrastar
        track.addEventListener("click", (e) => {
            if (hasMoved) {
                e.preventDefault();
                e.stopPropagation();
                hasMoved = false;
            }
        }, true);

        // Resize
        window.addEventListener("resize", () => {
            renderDots();
            goToSlide(currentIndex);
        });

        // Pausa o autoplay quando a aba não está visível
        document.addEventListener("visibilitychange", () => {
            if (document.hidden) {
                stopAutoplay();
            } else {
                startAutoplay();
            }
        });

        // Inicialização
        renderDots();
        startAutoplay();
    });
});